<script setup lang="ts">
const props = defineProps<{ message: string }>();
const safeMessage = computed(() => sanitizeHtml(props.message));
</script>

<template>
  <div class="fixed inset-0 z-100001 flex items-center justify-center overflow-auto bg-blue-900 text-blue-400 p-6" role="alert">
    <div class="mx-auto flex w-full max-w-md flex-col items-center gap-5 py-10 text-center">
      <h1 class="text-2xl font-semibold">{{ $t("status.blocking.title") }}</h1>
      <AppSafeHtml class="text-base leading-relaxed" :content="safeMessage" />
    </div>
  </div>
</template>
